<template>
  <d-navbar toggleable="md" type="dark" theme="primary" class="notifications_top">
    <d-collapse is-nav id="nav-collapse">
      <d-badge theme="primary"><i class="material-icons mr-2">person</i> {{userData.name + ' ' + userData.last_name}}</d-badge>
      <d-navbar-nav class="flex-fill">
        <d-nav-item class="navbar" style="justify-content: normal" v-if="userData.role !== 'R_HR' && userData.role !== 'R_USER'">
          <d-button
            theme="success"
            class="button__search_visit"
            @click.prevent="getVisitValue">
            <template v-if="!spinnerVisit">
              <i class="material-icons">search</i>
              <span class="ml-2">Szukaj terminu</span>
            </template>
            <template v-else>
              <div class="spinner-border spinner-border-sm" role="status"></div>
            </template>
          </d-button>
        </d-nav-item>
        <d-nav-item class="navbar" style="justify-content: normal" v-if="userData.role !== 'R_HR' && userData.role !== 'R_USER'">
          <d-button
            style="min-width: 12rem;"
            theme="danger"
            class="button__reservation_visit"
            @click.prevent="openReservations">
            <template v-if="!spinnerReservations">
              <i class="material-icons">add</i>
              <span class="ml-2">Dodaj do listy rezerwowej</span>
            </template>
            <template v-else>
              <div class="spinner-border spinner-border-sm" role="status"></div>
            </template>
          </d-button>
        </d-nav-item>
        <d-nav-item class="navbar">
          <d-button
            @click.prevent="handleClick" :title=" newMessage !== true ? 'Wiadomości' : 'Nowe wiadomości !'"
            :class="[ showModal ? 'button__notifications_active' : 'button__notifications_inactive']">
            <span v-if="newMessage === true" class="notification-head-dot-alert"></span>
            <i class="material-icons" style="transform: scale(1.5)">{{newMessage !== true ? 'notifications' : 'notifications_active'}}</i>
          </d-button>
        </d-nav-item>
        <d-nav-item class="navbar">
          <router-link title="Wyloguj się" :to="'/wyloguj'">
            <d-btn :class="[showModal ? 'button__close_active' : 'button__close_inactive']"><i class="material-icons logout" style="transform: scale(1.5);">power_settings_new</i></d-btn>
          </router-link>
        </d-nav-item>
        <aside :class="['main-sidebar', showModal ? 'sidebar__active' : 'sidebar__inactive']">
          <div class="nav-wrapper notifications-wrapper">
            <div class="sidebar__close">
              <d-button
                :title="'Zamknij'"
                class="notifications-button"
                @click.prevent="handleClick">
                <i class="material-icons notifications-button-icon">close</i>
              </d-button>
            </div>
            <d-nav class="flex-column mt-1" style="margin-top: 0 !important;">
              <d-card class="mb-5" style="border-radius: 0 !important;">
                <d-tabs card>
                  <d-tab title="Wszystkie" active>
                    <li
                      v-for="(item, index) in data"
                      :key="index" class="nav-item dropdown"
                      @click="copyListRead(index)"
                    >
                      <d-link
                        :class="[
                        'nav-link ',
                         item.reference_type === 'HOLIDAY' ? (item.date_read !== null ? 'nav-link-holidays' : 'nav-link-holidays-new') :
                         (item.reference_type === 'HOLIDAY_PLAN' ? (item.date_read !== null ? 'nav-link-plans' : 'nav-link-plans-new') :
                         (item.reference_type === 'RESERVATION_LIST' ? (item.date_read !== null ? 'nav-link-reservation' : 'nav-link-reservation-new') :
                         (item.reference_type === 'USER' ? (item.date_read !== null ? 'nav-link-reservation' : 'nav-link-reservation-new') :
                         (item.date_read !== null ? 'nav-link-visits' : 'nav-link-visits-new')))), item.items && item.items.length ? 'dropdown-toggle' : '']"
                        v-d-toggle="`snc-${index}-${item.title}`"
                        style="display: flex"
                        v-model="data[index].date_read"
                        @click="readItem(item.id)"
                      >
                        <i
                          :style="item.date_read === null ? 'color: #007bff' : ''"
                          :class="[
                          'material-icons', 'notifications-icon',
                          item.reference_type === 'HOLIDAY' ? 'notifications-icon-holidays' : (item.reference_type === 'HOLIDAY_PLAN' ? 'notifications-icon-plans' :
                         ( item.reference_type === 'RESERVATION_LIST' ? 'notifications-icon-reservation' : (item.reference_type === 'USER' ? 'notifications-icon-user' : '')))
                          ]">
                          {{item.date_read === null ? 'mail' : 'mail_outline' }}
                        </i>
                        <div class="form-group" style="display: block; white-space: normal;">
                          <span
                            :style="item.date_read === null ? 'font-weight: 700;' : ''"
                            class="notification-head-title"
                          >
                          {{item.reference_type === 'HOLIDAY' ? 'Wniosek urlopowy' : (item.reference_type === 'HOLIDAY_PLAN' ? 'Plan urlopowy' :
                            ( item.reference_type === 'RESERVATION_LIST' ? 'Rezerwacja' : (item.reference_type === 'USER' ?
                              'Użytkownik' : 'Rezerwacja wizyty')))}}
                        </span>
                          <div class="sidebar__active_box_content" style="white-space: normal">
                            {{ item.content + ' (' + 'termin: ' + item.created_at.slice(0, 16) + ') '}} <d-link>#{{item.reference_id}}</d-link>
                          </div>
                          <d-collapse :id="`snc-${index}-${item.title}`" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
                            <div class="mt-1">
                              <d-button
                                v-if="item.reference_type === 'HOLIDAY' || item.reference_type === 'HOLIDAY_PLAN'"
                                outline
                                :theme="item.reference_type === 'HOLIDAY' ? 'success' : 'warning'"
                                @click.prevent="$router.push(item.is_worker === 0 ? (item.reference_type === 'HOLIDAY' ? ('/urlopy/edycja/' + item.reference_id) : (item.reference_type === 'HOLIDAY_PLAN' ? '/plany-urlopowe' : '/kokpit')) :
                                (item.reference_type === 'HOLIDAY' ? ('/urlopy-pracownikow/edycja/' + item.reference_id) : (item.reference_type === 'HOLIDAY_PLAN' ? ('/plany-urlopowe/plan-urlopowy-pracownika/' + item.reference_id ) : '/kokpit')))">
                                {{ item.reference_type === 'HOLIDAY' ? 'Przejdź do wniosku urlopowego' : (item.reference_type === 'HOLIDAY_PLAN' ? 'Przejdź do planu urlopowego' : 'Przejdź do wizyty') }}
                              </d-button>
                              <d-button
                                v-if="item.reference_type === 'VISIT_RESERVATION'"
                                outline
                                theme="primary"
                                @click.prevent="$router.push('/wizyty/edycja/' + item.reference_id)">
                                Przejdź do wizyty
                              </d-button>
                              <d-button
                                v-if="item.reference_type === 'RESERVATION_LIST'"
                                outline
                                theme="primary"
                                @click.prevent="$router.push('/reservation_list/detale/' + item.reference_id)">
                                Przejdź do rezerwacji
                              </d-button>
                              <d-button
                                v-if="item.reference_type === 'USER'"
                                outline
                                theme="dark"
                                @click.prevent="$router.push('/uzytkownicy/edycja/' + item.reference_id)">
                                Przejdź do użytkownika
                              </d-button>
                            </div>
                          </d-collapse>
                        </div>
                        <span
                          :title="'Odznacz jako przeczytane'"
                          @click="readItem(item.id)"
                          v-if="item.date_read === null"
                          :class="[item.date_read === null ? (item.reference_type === 'HOLIDAY' ? 'notification-head-dot-new-holidays' :
                          (item.reference_type === 'HOLIDAY_PLAN' ? 'notification-head-dot-new-plans' :
                          (item.reference_type === 'RESERVATION_LIST' ? 'notification-head-dot-new-reservation' :
                          (item.reference_type === 'USER' ? 'notification-head-dot-new-user' : 'notification-head-dot-new-visits')))) : 'notification-head-dot-old']">
                        </span>
                        <span v-if="item.date_read !== null" class="notification-head-dot-old"></span>
                      </d-link>
                      <d-button
                        outline
                        pill
                        :title="'Usuń wiadomość'"
                        theme="light"
                        @click.prevent="removeItem(item.id)"
                        :disabled="removeInProgress"
                        class="notification-head-delete">
                        <i class="material-icons">delete</i>
                      </d-button>
                      <d-alert
                        v-if="loadError"
                        show
                        theme="warning">
                        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
                      </d-alert>
                    </li>
                    <d-link @click="readItemForceAll">
                      <p class="mt-3 mb-0 ml-3">Oznacz wszystkie jako przeczytane</p>
                    </d-link>
                  </d-tab>
                  <d-tab title="Nowe">
                    <li
                      v-for="(item, index) in data"
                      :key="index" class="nav-item dropdown"
                      @click="copyListReadNew(index)"
                      v-if="item.date_read === null || item.date_read === 'readNew'"
                    >
                      <d-link
                        :class="[
                        'nav-link ',
                          item.reference_type === 'HOLIDAY' ? (item.date_read !== null ? 'nav-link-holidays' : 'nav-link-holidays-new') :
                         (item.reference_type === 'HOLIDAY_PLAN' ? (item.date_read !== null ? 'nav-link-plans' : 'nav-link-plans-new') :
                         (item.reference_type === 'RESERVATION_LIST' ? (item.date_read !== null ? 'nav-link-reservation' : 'nav-link-reservation-new') :
                         (item.reference_type === 'USER' ? (item.date_read !== null ? 'nav-link-reservation' : 'nav-link-reservation-new') :
                         (item.date_read !== null ? 'nav-link-visits' : 'nav-link-visits-new')))), item.items && item.items.length ? 'dropdown-toggle' : '']"
                        v-d-toggle="`snc-${index}-${item.title}`"
                        style="display: flex"
                        v-model="data[index].date_read"
                        @click="readItem(item.id)"
                      >
                        <i
                          :style="item.date_read === null ? 'color: #007bff' : ''"
                          :class="[
                          'material-icons', 'notifications-icon',
                          item.reference_type === 'HOLIDAY' ? 'notifications-icon-holidays' : (item.reference_type === 'HOLIDAY_PLAN' ? 'notifications-icon-plans' :
                         ( item.reference_type === 'RESERVATION_LIST' ? 'notifications-icon-reservation' : (item.reference_type === 'USER' ? 'notifications-icon-user' : '')))
                          ]">
                          {{item.date_read === null ? 'mail' : 'mail_outline' }}
                        </i>
                        <div class="form-group" style="display: block; white-space: normal;">
                          <span
                            :style="item.date_read === null ? 'font-weight: 700;' : ''"
                            class="notification-head-title"
                          >
                          {{item.reference_type === 'HOLIDAY' ? 'Wniosek urlopowy' : (item.reference_type === 'HOLIDAY_PLAN' ? 'Plan urlopowy' :
                            ( item.reference_type === 'RESERVATION_LIST' ? 'Rezerwacja' : (item.reference_type === 'USER' ?
                              'Użytkownik' : 'Rezerwacja wizyty')))}}
                        </span>
                          <div class="sidebar__active_box_content" style="white-space: normal">
                            {{ item.content + ' (' + 'termin: ' + item.created_at.slice(0, 16) + ') '}} <d-link>#{{item.reference_id}}</d-link>
                          </div>
                          <d-collapse :id="`snc-${index}-${item.title}`" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
                            <div class="mt-1">
                              <d-button
                                v-if="item.reference_type === 'HOLIDAY' || item.reference_type === 'HOLIDAY_PLAN'"
                                outline
                                :theme="item.reference_type === 'HOLIDAY' ? 'success' : 'warning'"
                                @click.prevent="$router.push(item.is_worker === 0 ? (item.reference_type === 'HOLIDAY' ? ('/urlopy/edycja/' + item.reference_id) : (item.reference_type === 'HOLIDAY_PLAN' ? '/plany-urlopowe' : '/kokpit')) :
                                (item.reference_type === 'HOLIDAY' ? ('/urlopy-pracownikow/edycja/' + item.reference_id) : (item.reference_type === 'HOLIDAY_PLAN' ? ('/plany-urlopowe/plan-urlopowy-pracownika/' + item.reference_id ) : '/kokpit')))">
                                {{ item.reference_type === 'HOLIDAY' ? 'Przejdź do wniosku urlopowego' : (item.reference_type === 'HOLIDAY_PLAN' ? 'Przejdź do planu urlopowego' : 'Przejdź do wizyty') }}
                              </d-button>
                              <d-button
                                v-if="item.reference_type === 'VISIT_RESERVATION'"
                                outline
                                theme="primary"
                                @click.prevent="$router.push('/wizyty/edycja/' + item.reference_id)">
                                Przejdź do wizyty
                              </d-button>
                              <d-button
                                v-if="item.reference_type === 'RESERVATION_LIST'"
                                outline
                                theme="primary"
                                @click.prevent="$router.push('/reservation_list/detale/' + item.reference_id)">
                                Przejdź do rezerwacji
                              </d-button>
                              <d-button
                                v-if="item.reference_type === 'USER'"
                                outline
                                theme="dark"
                                @click.prevent="$router.push('/uzytkownicy/edycja/' + item.reference_id)">
                                Przejdź do użytkownika
                              </d-button>
                            </div>
                          </d-collapse>
                        </div>
                        <span
                          :title="'Odznacz jako przeczytane'"
                          @click="readItem(item.id)"
                          v-if="item.date_read === null"
                          :class="[item.date_read === null ? (item.reference_type === 'HOLIDAY' ? 'notification-head-dot-new-holidays' :
                          (item.reference_type === 'HOLIDAY_PLAN' ? 'notification-head-dot-new-plans' :
                          (item.reference_type === 'RESERVATION_LIST' ? 'notification-head-dot-new-reservation' :
                          (item.reference_type === 'USER' ? 'notification-head-dot-new-user' : 'notification-head-dot-new-visits')))) : 'notification-head-dot-old']">
                        </span>
                        <span v-if="item.date_read !== null" class="notification-head-dot-old"></span>
                      </d-link>
                      <d-button
                        outline
                        pill
                        :title="'Usuń wiadomość'"
                        theme="light"
                        @click.prevent="removeItem(item.id)"
                        :disabled="removeInProgress"
                        class="notification-head-delete">
                        <i class="material-icons">delete</i>
                      </d-button>
                      <d-alert
                        v-if="loadError"
                        show
                        theme="warning">
                        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
                      </d-alert>
                    </li>
                    <li v-else-if="index === 0">
                      <h4 class="mt-3 pb-3"> Brak nowych wiadomości</h4>
                    </li>
                    <d-link @click="readItemForceAll">
                      <p class="mt-3 mb-0 ml-3">Oznacz wszystkie jako przeczytane</p>
                    </d-link>
                  </d-tab>
                </d-tabs>
              </d-card>
            </d-nav>
          </div>
        </aside>
      </d-navbar-nav>
    </d-collapse>
    <visits-form-popup
      :key="visitsFormPopupKey"
      :close-modal="closeVisitValue"
      :show-modal="showModalVisit"
      :institutions-arr="institutions"/>
    <reservation-list-form-add
      :key="'reservation-' + reservationsFormPopupKey"
      :close-modal="closeReservations"
      :show-modal="showModalReservations">
    </reservation-list-form-add>
  </d-navbar>
</template>

<script>
import axios from 'axios'
import ListUtils from '../../utils/ListUtils.js';
import FormUtils from '../../utils/FormUtils.js';
import VisitsFormPopup from '../forms/Visits/VisitsFormPopup';
import ReservationListFormAdd from '../forms/ReservationListFormAdd';
import api from '@/api'

export default {
  name: 'Notifications',
  components: { ReservationListFormAdd, VisitsFormPopup },
  data() {
    return {
      data: {},
      newMessage: false,
      showModal: false,
      showModalVisit: false,
      showModalReservations: false,
      loaded: false,
      loadError: false,
      removeInProgress: false,
      spinnerVisit: false,
      spinnerReservations: false,
      visitsFormPopupKey: 0,
      reservationsFormPopupKey: 0,
      notifications: {},
      institutions: [],
      users: [],
    }
  },
  watch: {
    'showModalVisit': function () {
      this.visitsFormPopupKey += 1;
    },
    'showModalReservations': function () {
      this.reservationsFormPopupKey += 1;
    }
  },
  computed: {
    userData () {
      return this.$store.getters.getAccount
    },
  },
  methods: {
    getVisitValue () {
      this.spinnerVisit = true;
      this.getInstitutions();
      setTimeout(() => {
        this.spinnerVisit = false;
        this.showModalVisit = true;
      }, 500);
    },
    openReservations () {
      this.spinnerReservations = true;
      this.getInstitutions();
      setTimeout(() => {
        this.spinnerReservations = false;
        this.showModalReservations = true;
      }, 500);
    },
    closeVisitValue () {
      this.showModalVisit = false;
    },
    closeReservations () {
      this.showModalReservations = false;
    },
    getInstitutions () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items',
        outputKey: 'institutions',
        params: {
          pagination: false
        },
      });
    },
    isThereANewMessage () {
      const notifications = this.notifications;
      let newNotifications = [];
      for (let i = 0; i < notifications.length; i++) {
        newNotifications[i] = notifications[i].date_read
      }
      this.newMessage = newNotifications.includes(null)
    },
    copyList() {
      this.data = JSON.parse(JSON.stringify(this.notifications));
    },
    copyListRead(index) {
      this.data[index].date_read = 'read';
    },
    copyListReadNew(index) {
      this.data[index].date_read = 'readNew';
    },
    handleClick() {
      this.showModal = !this.showModal;
    },
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
    getUsersList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'users',
      });
    },
    loadNotifications () {
      ListUtils.loadItemsData(this, {
        endpoint: '/notifications/items',
        listField: 'notifications',
        pagination: false,
      });
    },
    readItem (readItem) {
      axios({
        method: 'post',
        url: `${api}notifications/read/` + readItem
      }).catch((error) => {
        console.log(error);
      });
    },
    readItemForceAll () {
      ListUtils.removeItem(this, {
        endpointBase: '/notifications/',
        id: 'read-all',
        successTitle: 'Oznaczono wszystko jako przeczytane',
        successText: 'Wszystkie wiadomość została oznaczona jako przeczytane',
        confirmTitle: 'Czy na pewno chcesz oznaczyć wszystkie wiadomości jako przeczytane?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Odznaczanie wiadomości nie powiodło się. Spróbuj ponownie.',
        confirmButtonText: 'Tak',
        successAction: () => {
          window.location.reload();
        },
      });
    },
    removeItem (notificationID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/notifications/delete/',
        id: notificationID,
        successTitle: 'Usunięto wiadomość',
        successText: 'Wybrana wiadomość została usunięta',
        confirmTitle: 'Czy na pewno chcesz usunąć tą wiadomość?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie wiadomości nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadNotifications();
          setTimeout(() => {
            this.copyList();
          }, 500);
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  },
  mounted () {
    setTimeout(() => {
      this.copyList();
      this.isThereANewMessage();
    }, 500);
    this.getUsersList();
    this.userAccountGet();
    this.loadNotifications();
  }
}

</script>

<style lang="scss">
  @import '../../assets/scss/layout/main-navbar.scss';
</style>
